<template>
  <div class="monitorPlatformOne monitoring-interface-content">
    <Row>
      <Col span="24">
        <div class="panel">
          <div class="panel-title">
            <span>{{t('最近菜单')}}</span>
          </div>
          <div class="panel-content" style="display: flex;flex-wrap: nowrap;justify-content: space-between;">
            <div>
              <span
                class="menu-item"
                v-for="menu in menus"
                :key="menu.id">
                <span @click="routeTo(menu)">{{ menu.label }}</span>
                <Icon type="md-close-circle" @click="handleMenu(menu, false)" />
              </span>
            </div>

            <Poptip v-if="false" placement="bottom" width="400" transfer @on-popper-show="searchChange" @on-popper-hide="toggleMenu">
              <Button icon="ios-add-circle-outline" type="dashed" size="small">{{t('添加常用菜单')}}</Button>
              <div class="api card-wrap" slot="content">
                <div class="menus">
                  <Input v-model="searchValue" prefix="ios-search" :placeholder="t('搜索菜单的名称')" style="width: auto" @on-change="searchChange" />
                  <div class="search-result">
                    <p>{{t('你可能想添加')}}：</p>
                    <div style="display: flex;flex-wrap: wrap;">
                      <Button
                        v-for="(menu,index) of searchMenus"
                        :key="menu.id"
                        type="primary"
                        :icon="menu.icon || 'ios-add-circle-outline'"
                        @click="handleMenu(menu, true)">{{ menu.label }}</Button>
                    </div>
                  </div>
                </div>
              </div>
            </Poptip>
          </div>
        </div>
      </Col>
    </Row>
    <Row v-loading="pageLoading">
      <Col span="16">
        <div class="panel panel-container">
          <div class="panel-title">
            <span>{{t('预警')}}</span>
            <Select v-if="false" v-model="showWhat" size="small" class="selectPanelShow">
              <Option v-for="item in sheetOptions" :value="item.value" :key="item.value">{{ item.label }}</Option>
            </Select>
            <div style="margin-left: 1rem;">
              <div class="index-update-time" @click="init">
                {{t('更新')}}<Icon type="md-refresh" />
              </div>
            </div>
          </div>
          <div v-show="isShowBar">
            <div class="panel-content">
              <div style="justify-content: space-between; display: flex; position: absolute; right: 16px;">
                <div class="index-update-time" @click="init">
                  {{t('更新')}}<Icon type="md-refresh" />
                </div>
              </div>

              <div :class="{'warning-list': true, isShowBar}" id="orderForwardBar">
              </div>
            </div>
            <div class="panel-content">
              <div :class="{'warning-list': true, isShowBar}" id="orderReverseBar">
              </div>
            </div>
          </div>
          <div v-show="!isShowBar">
            <div class="panel-content order-content-box">
              <div class="order-content-header">
                <div class="order-text">
                  <div>
                    <img src="/static/img/index/order-z-icon.png" alt=""/>
                    {{t('订单正向')}}：
                  </div>
                  <!-- <Icon type="md-settings" @click="handleDialog(1)" /> -->
                </div>
                <ul class="index-update-list" @click="init">
                  <li v-for="(item, index) in [1,2,3,4,5]" :key="index" :class="{ 'active': item < 4 }">
                    <span>·</span>
                  </li>
                </ul>
              </div>
              <div class="warning-list" id="sortable-forward">
                <div
                  v-for="info in warningList1"
                  :key="info.title"
                  class="warning-info flow-layer"
                >
                  <div class="warning-title" :class="[info.count > 0 ? 'warning' : 'normal']">
                    <Tooltip :content="`${t('更新时间')}: ${info.LAST_TIME || ''}`" transfer placement="top-start">
                      <span class="warning-count" @click="jumpTo(1, info.title)">{{ info.count }}</span>
                    </Tooltip>
                  </div>
                  <Tooltip :content="`${t('任务详细说明')}: ${info.LAST_TIME || ''}`" transfer placement="bottom-start">
                    <div class="warning-subtitle">
                        <img :src="imgSrcList[info.title]" width="13px" height="13px" />
                        <p>{{ info.title }}</p>
                    </div>
                  </Tooltip>
                </div>
              </div>
            </div>
            <div class="panel-content order-content-box">
              <div class="order-content-header">
                <div class="order-text">
                  <div>
                    <img src="/static/img/index/order-n-icon.png" alt=""/>
                    {{t('订单逆向')}}：
                  </div>
                  <!-- <Icon type="md-settings"  @click="handleDialog(2)" /> -->
                </div>
              </div>
              <div class="warning-list" id="sortable-backward">
                <div
                  v-for="info in warningList2"
                  :key="info.title"
                  class="warning-info flow-layer"
                >
                  <div class="warning-title" :class="[info.count > 0 ? 'warning' : 'normal']">
                    <Tooltip :content="`${t('更新时间')}: ${info.LAST_TIME || ''}`" transfer placement="top-start">
                      <span class="warning-count" @click="jumpTo(2, info.title)">{{ info.count }}</span>
                    </Tooltip>
                  </div>
                  <Tooltip :content="`${t('任务详细说明')}: ${info.LAST_TIME || ''}`" transfer placement="bottom-start">
                    <div class="warning-subtitle">
                      <img :src="imgSrcList[info.title]" width="13px" height="13px" />
                      <p>{{ info.title }}</p>
                    </div>
                  </Tooltip>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- <backlog ref="backlog" /> -->
        <div class="panel">
          <div class="panel-title">
            <span>{{t('今日数据')}}</span>
          </div>
          <div class="panel-content today-data">
            <OmsTable :jordan-table-config="tableConfig1" style="width: 50%" />
            <OmsTable :jordan-table-config="tableConfig2" style="width: 50%" />
          </div>
        </div>
      </Col>
      <Col span="8" class="page-right">
        <div class="panel">
          <div class="panel-title">
            <span>{{t('通知消息')}}</span>
          </div>
          <div class="panel-content">
            <OmsTable :jordan-table-config="tableConfig3" />
          </div>
        </div>
        <div class="panel panel-5">
          <div class="panel-title">
            <span>{{t('公告信息')}}</span>
          </div>
          <div class="panel-content">
            <OmsTable :jordan-table-config="tableConfig5" />
          </div>
        </div>
        <div class="panel panel-2">
          <div class="panel-title">
            <span>{{t('促销活动')}}</span>
          </div>
          <div class="panel-content">
            <OmsTable :jordan-table-config="tableConfig4" />
          </div>
        </div>
      </Col>
    </Row>
    <OmsDialog
      :title="publicBouncedConfig.title"
      :title-align="publicBouncedConfig.titleAlign"
      :width="publicBouncedConfig.width"
      :scrollable="publicBouncedConfig.scrollable"
      :closable="publicBouncedConfig.closable"
      :draggable="publicBouncedConfig.draggable"
      :mask="publicBouncedConfig.mask"
      :mask-closable="publicBouncedConfig.maskClosable"
      :transfer="publicBouncedConfig.transfer"
      :name="publicBouncedConfig.name"
      :url="publicBouncedConfig.url"
      :batch-closed="publicBouncedConfig.batchClosed"
      :keep-alive="publicBouncedConfig.keepAlive"
      :exclude-string="publicBouncedConfig.excludeString"
      :component-data="publicBouncedConfig.componentData"
      :quit="publicBouncedConfig.quit"
    />
  </div>
</template>

<script>
import { mapState } from "vuex";
import utils from '@/assets/js/__utils__/route.js';
// import backlog from "./backlog.vue";
import echartMixin from "./oneEchart.mixin"

const DEFAULT_COUNT_VALUE = 0

export default {
  mixins: [echartMixin],
  components: {
    // backlog,
  },
  data() {
    return {
      showWhat: 'default',
      sheetOptions: [
        { label: t('默认'), value: 'default' },
        { label: t('柱状图'), value: 'bar' },
      ],
      isShowBar: false,
      pageLoading: false,
      menus: [], // 常用菜单
      searchValue: '',
      searchMenus: [],
      warningList1: [
        { title: t('待分配'), count: 0, icon: 'backlog-ptwfh-icon.png' },
        { title: t('已审核'), count: 0, icon: 'backlog-tkcg-icon.png' },
        { title: t('待传WMS'), count: 0, icon: 'wms-icon.png' },
        { title: t('异常订单'), count: 0, icon: 'backlog-wwjtk-icon.png' },
        { title: t('即将超时订单'), count: 0, icon: 'backlog-ckwfh-icon.png' },
        { title: t('超时订单'), count: 0, icon: 'backlog-timeout-icon.png' },
        { title: t('平台发货失败'), count: 0, icon: 'backlog-fail-icon.png' },
      ],
      warningList2: [
        { title: t('待拦截订单'), count: 0, icon: 'backlog-ljqj-icon.png' },
        { title: t('售后传WMS异常单'), count: 0, icon: 'wms-icon.png' },
        { title: t('售后异常'), count: 0, icon: 'backlog-wwj-icon.png' },
        { title: t('待售后审核'), count: 0, icon: 'fh-icon.png' },
      ],
      imgSrcList: {
        "平台发货失败": "/static/img/index/backlog-fail-icon.png",
        "待分配": "/static/img/index/backlog-ptwfh-icon.png",
        "即将超时订单": "/static/img/index/backlog-ckwfh-icon.png",
        "超时订单": "/static/img/index/backlog-timeout-icon.png",
        "已审核": "/static/img/index/backlog-tkcg-icon.png",
        "异常订单": "/static/img/index/backlog-wwjtk-icon.png",
        "待拦截订单": "/static/img/index/backlog-ljqj-icon.png",
        "售后传WMS异常单": "/static/img/index/wms-icon.png",
        "待传WMS": "/static/img/index/wms-icon.png",
        "售后异常": "/static/img/index/backlog-wwj-icon.png",
        "待售后审核": "/static/img/index/fh-icon.png"
      },
      tableConfig1: {
        stripe: true,
        indexColumn: false,
        isShowSelection: false,
        columns: [
          {
            key: 'title',
            title: t('类型'),
          },
          {
            key: 'count',
            title: t('单数')
          },
        ],
        data: [],
        pageShow: false, // 控制分页是否显示
        btnsShow: false, // 控制操作按钮是否显示
        searchInputShow: false, // 控制搜索框是否显示
        width: '', // 表格宽度
        height: '', // 表格高度
        border: true, // 是否显示纵向边框
        total: 0, // 设置总条数
      },
      tableConfig2: {
        stripe: true,
        indexColumn: false,
        isShowSelection: false,
        columns: [
          {
            key: 'title',
            title: t('类型'),
          },
          {
            key: 'count',
            title: t('单数')
          },
        ],
        data: [],
        pageShow: false, // 控制分页是否显示
        btnsShow: false, // 控制操作按钮是否显示
        searchInputShow: false, // 控制搜索框是否显示
        width: '', // 表格宽度
        height: '', // 表格高度
        border: true, // 是否显示纵向边框
        total: 0, // 设置总条数
      },
      tableConfig3: {
        stripe: true,
        indexColumn: false,
        isShowSelection: false,
        columns: [
          {
            key: 'name',
            title: t('通知'),
          },
          {
            key: 'taskstate',
            title: t('操作')
          },
          {
            key: '',
            title: t('链接'),
            render: (h, params) => {
              return h('a',
                {
                  on: {
                    click: () => {
                      this.$store.commit('global/tabOpen', {
                        type: 'V',
                        tableName: 'CP_C_TASK',
                        label: t('我的任务'),
                        tableId: 24386,
                        id: params.row.id,
                        query: {
                          id: params.row.id,
                          pid: '10010',
                          ptitle: t('我的任务'),
                          ptype: 'table',
                          tabTitle: t('我的任务'),
                          tableName: 'CP_C_TASK'
                        }
                      });
                    }
                  }
                }, t('详情'))
            }
          },
        ],
        data: [],
        pageShow: false, // 控制分页是否显示
        btnsShow: false, // 控制操作按钮是否显示
        searchInputShow: false, // 控制搜索框是否显示
        width: '', // 表格宽度
        height: '180', // 表格高度
        border: true, // 是否显示纵向边框
        total: 0, // 设置总条数
      },
      tableConfig4: {
        stripe: true,
        indexColumn: true,
        isShowSelection: false,
        columns: [
          {
            key: 'name',
            title: t('营销活动'),
          },
          {
            key: 'start_time',
            title: t('开始时间')
          },
          {
            key: 'end_time',
            title: t('结束时间')
          },
          {
            key: 'free_quantity',
            title: t('已送数量')
          },
        ],
        data: [],
        pageShow: false, // 控制分页是否显示
        btnsShow: false, // 控制操作按钮是否显示
        searchInputShow: false, // 控制搜索框是否显示
        width: '', // 表格宽度
        height: '180', // 表格高度
        border: true, // 是否显示纵向边框
        total: 0, // 设置总条数
      },
      tableConfig5: {
        stripe: true,
        indexColumn: true,
        isShowSelection: false,
        columns: [
          {
            key: 'name',
            title: t('公告'),
            render: (h, params) => {
              return h('a',
                {
                  on: {
                    click: () => {
                      vm.$store.commit("global/tabOpen", {
                        type: "V",
                        url: `/SYSTEM/TABLE_DETAIL/V/CP_C_SYSTEM_NOTICE/249232233/${params.row.id}?FROM=WEL`,
                      });
                    }
                  }
                }, params.row.name)
            }
          },
        ],
        data: [],
        pageShow: false, // 控制分页是否显示
        btnsShow: false, // 控制操作按钮是否显示
        searchInputShow: false, // 控制搜索框是否显示
        width: '', // 表格宽度
        height: '180', // 表格高度
        border: true, // 是否显示纵向边框
        total: 0, // 设置总条数
      },
      publicBouncedConfig: {
        title: t('选择任务'),
        width: 1000,
        url: require('@/views/pages/monitorPlatform/chooseTask.vue').default,
        name: 'chooseTask',
        excludeString: 'chooseTask',
        scrollable: false, // 是否可以滚动
        closable: true, // 是否可以按esc关闭
        draggable: true, // 是否可以拖动
        mask: true, // 是否显示遮罩层
        maskClosable: true, // 是否可以点击叉号关闭
        transfer: true, // 是否将弹层放在body内
        keepAlive: true,
        componentData: {}
      },
    }
  },
  deactivated() {
    this.timer && clearTimeout(this.timer)
  },
  mounted() {
    this.timer = setTimeout(() => {
      this.init()
    }, 1000 * 60 * 5)
    // this.menus = localStorage.getItem(`${this.userInfo.id}_useMenus`) ? JSON.parse(localStorage.getItem(`${this.userInfo.id}_useMenus`)) : []
    // this.showWhat = localStorage.getItem('showWhatEchart') || 'default'
  },
  computed: {
    ...mapState('global', ['menuLists', 'history', 'userInfo']),
    allMenus() {
      let arr = []
      this.menuLists.map(i => {
        if (i.children && i.children.length) {
          i.children.map(ii => {
            if (ii.children && ii.children.length) {
              ii.children.map(iii => {
                arr.push(iii)
              })
            } else {
              arr.push(ii)
            }
          })
        } else {
          arr.push(i)
        }
      })
      return arr
    },
  },
  watch: {
    "$store.state.global.history": {
      handler(v) {
        if (v.length) {
          this.menus = JSON.parse(JSON.stringify(v)).reverse()
        }
      },
      immediate: true
    },
    showWhat: {
      handler(val) {
        if (val == 'bar') {
          this.isShowBar = true;
          setTimeout(() => {
            this.showEchart()
          }, 100);
        } else {
          this.isShowBar = false
        }
        localStorage.setItem('showWhatEchart', val)
      }
    },
    userInfo: {
      handler(val) {
        if (val && val.id) {
          this.init()
        }
      },
      immediate: true,
      deep: true
    }
  },
  methods: {
    init() {
      // return
      if (this.$route.fullPath != '/') return
      this.pageLoading = true
      const formData = new FormData()
      formData.append('userId', this.userInfo.id)
      this.service.common.homePageWorkBenchQuery(formData).then(res => {
        console.log(res)
        if (res.data.code == 0) {
          const { early_warning, return_order, today_data, notice, marketing_activities, systemNoticeData } = res.data.data || {}
          this.warningList1 = early_warning.order
          this.warningList2 = early_warning.return_order
          this.tableConfig1.data = today_data.slice(0, 4)
          this.tableConfig2.data = today_data.slice(4)
          this.tableConfig3.data = notice.data
          this.tableConfig4.data = marketing_activities.data
          this.tableConfig5.data = systemNoticeData ? systemNoticeData.data : []
          setTimeout(() => {
            const height1 = $('.page-right').height()
            const th = (height1 - (20+26+10+15)*3) / 3
            this.tableConfig3.height = th
            this.tableConfig4.height = th
            this.tableConfig5.height = th
          }, 1);
          if (this.isShowBar == true) {
            setTimeout(() => {
              this.showEchart()
            }, 100);
          }
        } else {
          this.warningList1 = []
          this.warningList2 = []
          this.tableConfig1.data = []
          this.tableConfig2.data = []
          this.tableConfig3.data = []
          this.tableConfig4.data = []
        }
      }).finally(e => {
        this.pageLoading = false
        this.$nextTick(() => {
          $('#sortable-forward').sortable()
          $('#sortable-backward').sortable()
        })
      })
    },
    routeTo(menu) {
      utils.routeTo(menu)
    },
    toggleMenu() {
      this.searchValue = ''
      this.searchChange()
    },
    searchChange(e) {
      if (this.searchValue == '') {
        let tempMenus = []
        this.history.map(i => {
          let index = this.menus.findIndex(m => i.label == m.label)
          if (index === -1) {
            tempMenus.push(i)
          }
        })
        this.history.map(i => {
          this.updateMenuStatus(tempMenus, i, false)
        })
        this.searchMenus = tempMenus
        return
      }
      let resultMenus = this.allMenus.filter(i => i.label.indexOf(this.searchValue) !== -1)
      if (this.menus.length) {
        this.menus.map(i => {
          this.updateMenuStatus(resultMenus, i, true)
        })
      }
      this.searchMenus = resultMenus
    },
    handleMenu(menu, isAdd) {
      // 菜单显示固定的数量，超过后，增加新的常用菜单，自动替补最后一个菜单；
      const MAX = 8 // 菜单显示固定数
      if (isAdd) {
        if (menu.isDisabled) return
        if (this.menus.length == MAX) {
          this.handleMenu(this.menus.slice(-1)[0], false)
        }
        this.menus.push(menu)
      } else {
        this.menus = this.menus.filter(i => i.label != menu.label)
      }
      localStorage.setItem(`${this.userInfo.id}_useMenus`, JSON.stringify(this.menus))
      if (!this.searchMenus.length) return
      this.updateMenuStatus(this.searchMenus, menu, isAdd)
    },
    updateMenuStatus(menuList, menu, isAdd) {
      let index = menuList.findIndex(i => i.label == menu.label)
      if (index !== -1) {
        menuList[index].icon = isAdd ? 'ios-checkmark-circle-outline' : ''
        menuList[index].isDisabled = isAdd
      }
    },
    handleDialog(type) {
      let max, title
      if (type == 1) {
        title = t('订单正向')
        max = 10
      } else {
        title = t('订单逆向')
        max = 5
      }
      this.publicBouncedConfig.title = `${title}-${t('选择任务')}`
      this.publicBouncedConfig.componentData = Object.assign(this.publicBouncedConfig.componentData, {
        type,
        max
      });
      this.$children.find(item => item.name === 'chooseTask').openConfirm();
    },
    jumpTo(tag, title) {
      if (tag == 1) { // 订单正向
        const query = {
          id: 2627,
          tabTitle: t('零售发货单'),
        }
        switch (title) {
          case '待分配':
          case '已审核':
          case '待传WMS':
          case '异常订单':
          case '平台发货失败':
          case '即将超时订单':
          case '超时订单':
            query.activeTab = title
            break;
          default:
            break;
        }
        this.$store.commit('customize/TabHref', {
          id: 2627,
          type: 'action',
          name: 'orderManager',
          label: t('零售发货单'),
          back: true,
          query
        });
      } else { // 订单逆向

      }
    }
  }
}
</script>

<style lang="less" scoped>
.flow-layer {
  position: relative;
  z-index: 0;
  border-radius: 5px;
  &:before, &:after {
    content: "";
    position: absolute;
    top: -2px;
    left: -2px;
    right: -2px;
    bottom: -2px;
    border: 2px solid var(--b2-color);
    border-radius: 5px;
    transition: all .5s;
    animation: clippath 3s linear infinite;
    opacity: 0;
    z-index: -1;
  }
  &:after {
    animation: clippath 3s linear -1.5s infinite;
  }
  &:hover:before, &:hover:after {
    opacity: 0.5;
  }
  @keyframes clippath {
    0%, 100% {
        clip-path: inset(0 0 98% 0);
    }
    25% {
        clip-path: inset(0 98% 0 0);
    }
    50% {
        clip-path: inset(98% 0 0 0);
    }
    75% {
        clip-path: inset(0 0 0 98%);
    }
  }
}
.monitorPlatformOne {
  .index-update-list {
    display: flex;
    font-size: 1.8rem;
    li.active {
      color: var(--b2-color);
    }
  }
  button.ark-btn {
    &.ark-btn-dashed.ark-btn-small {
      border: 1px solid var(--s-border) !important;
      color: #515a6e;
    }
  }
  .selectPanelShow {
    margin-left: 10px;
    margin-top: 2px;
    width: 80px;
    /deep/.ark-select-selection {
      border-color: #f3f3f3;
      font-weight: normal;
    }
  }
  .page-right {
    position: absolute;
    right: 0;
    height: 100%;
    display: flex;
    flex-direction: column;
    .panel-2 {
      height: 100%;
      flex: 1;
    }
  }
}
.card-wrap {
  position: relative;
  .menus {
    &:hover {
      box-shadow: 1px 1px 2px 1px #e8eaec;
    }
    .search-result {
      margin-top: 10px;
      width: 100%;
      max-height: 213px;
      overflow-y: scroll;
      & > p {
        margin-bottom: 10px;
      }

      /deep/ button.ark-btn.ark-btn-primary, body button.ark-btn.ark-btn-primary:hover {
        background-color: #f7f9fa;
        border-color: #f7f9fa;
        color: #333;
        i {
          float: right;
          margin-left: 5px;
        }
        .iconios-add-circle-outline {
          color: var(--b2-color);
        }
        .iconios-checkmark-circle-outline {
          color: #000;
        }
        span {
          vertical-align: middle;
        }
      }
    }
  }
}
.monitoring-interface-content {
  width: 100%;
  background: #eef2f5;
  padding-right: 15px;
  padding-top: 15px;

  .panel {
    background: #fff;
    margin: 0 0 15px 15px;
    padding: 10px 16px;
    // box-shadow: 0 7px 9px 0 rgba(0,0,0,.1);
    border-radius: 5px;
    &:hover {
      box-shadow: 0 7px 9px 0 rgba(0, 0, 0, 0.2);
    }
    .panel-title {
      font-size: 18px;
      color: #262626;
      letter-spacing: 0;
      line-height: 26px;
      font-weight: bold;
      position: relative;
      margin-bottom: 10px;
      display: flex;
      align-items: center;
      // justify-content: space-between;
      /deep/ .cust-more {
        color: #313c52;
        border-color: transparent;
        &:hover {
          text-decoration: initial;
          background-color: #f1f1f1;
        }
        i.iconmd-more {
          font-size: 18px;
        }
      }
    }
    .panel-content {
      &.order-content-box {
        // background-color: #eef2f5;
        // box-shadow: 1px 4px 5px #e0dcdc;
        border: 1px solid var(--s-border);
        border-radius: 5px;
        &:first-child {
          margin-bottom: 12px;
        }
        &:last-child {
          margin-bottom: 6px;
        }
        .order-content-header {
          justify-content: space-between;
          display: flex;
          // border: 1px solid var(--s-border);
          border-left: none;
          border-right: none;
          padding: 8px 12px;
          .index-update-list {
            display: none;
          }
        }
      }
      .menu-item {
        position: relative;
        display: inline-block;
        margin: 0 1.5rem 5px 0;
        cursor: pointer;
        span {
          display: inline-block;
          padding: 4px 8px;
          color: var(--b2-color);
          font-size: 0.875rem;
          border-bottom: 1px solid var(--b2-color);
          border-radius: 1px;
        }
        i {
          display: none;
        }
        &:hover i {
          position: absolute;
          right: -10px;
          top: -2px;
          display: inline-block;
        }
      }
    }
    .index-update-time {
      color: #0179ff;
      cursor: pointer;
      display: flex;
      align-items: center;
      font-size: 0.8rem;
      margin-top: 3px;
      font-weight: 500;
    }
  }

  .warning-list {
    width: 100%;
    /* display: flex;
    justify-content: flex-start;
    flex-wrap: nowrap;
    overflow-x: auto; */
    padding: 0 4px 8px;
    display: grid;
    grid-template-columns: repeat(5, calc(20% - 3px));
    gap: 4px;
    // background-color: #eef2f5;
    // overflow: hidden;
    &#orderForwardBar,
    &#orderReverseBar {
      min-height: 200px;
    }
    .warning-info {
      display: flex;
      align-items: center;
      justify-content: flex-start;
      flex-direction: column;
      color: #111111;
      padding: 1rem 0;
      background-color: #eff2f5;
      border-radius: 5px;
      // width: 20%;
      // margin-right: 3%;
      // margin-bottom: 3%;
      // border: 1px solid #ccc;
      // border-radius: 1rem;
      // flex-shrink: 0;
      // cursor: pointer;
      &:hover {
        background-color: #e5ebef;
      }
      &:nth-child(5n) {
        margin-right: 0 !important;
      }
      img {
        margin-right: 10px;
      }
      .warning-title {
      }
      .warning-subtitle {
        display: flex;
        justify-content: center;
        align-items: center;
      }
      .warning-count {
        font-weight: bold;
        font-size: 1.6rem;
        cursor: pointer;
      }
      p {
        color: #595f68;
        font-size: 0.8rem;
      }
    }
  }

  .order-title {
    position: relative;
    height: 30px;
    display: flex;
    align-items: center;
  }

  .order-text {
    // width: calc(100% - 100px);
    // padding-right: 2rem;
    display: flex;
    align-items: center;
    font-size: 15px;
    color: #111111;
    letter-spacing: 0;
    overflow: hidden;
    justify-content: space-between;
    width: 100%;
  }

  .order-text img {
    width: 20px;
    height: 18px;
    margin-right: 4px;
    position: relative;
    top: -30px;
    filter: drop-shadow(0 30px red);
  }

  .today-data {
    display: flex;
  }
}
</style>
